import { render } from "./CadastrarClinica.vue?vue&type=template&id=51632e54&scoped=true"
import script from "./CadastrarClinica.vue?vue&type=script&lang=js"
export * from "./CadastrarClinica.vue?vue&type=script&lang=js"

import "./CadastrarClinica.vue?vue&type=style&index=0&id=51632e54&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51632e54"]])

export default __exports__